<template>
  <div>
    <el-drawer
      :title="this.Title"
      :visible.sync="showDrawerAmonestacionReport"
      :before-close="closeDrawerDetalles"
      @closed="closeDrawerDetalles"
      size="1000px"
    >
      <rabbey-table-3
        :data="amonestacionData"
        :actions="actions"
        :loading="autoLoading"
        @rtable-push-action="onPushAction"
        :columns="ColumnsDetalles"
      ></rabbey-table-3>
    </el-drawer>
    <DrawerAmonestacion
      ref="amonestacionForm"
      :visible.sync="amonestacionDrawer"
      @update-data="onPushAction(actionRowData)"
    ></DrawerAmonestacion>
  </div>
</template>
<script>
import ColumnsAmonestacionForMonth from "@/columns/ColumnsAmonestacionForMonth";
import DrawerAmonestacion from "@/views/apps/employees/RRHH/Modules/Amonestacion/DrawerAmonestacion.vue";
import Vue from "vue";

const vue = new Vue();
export default {
  name: "AmonestacionesReportForMes",
  components: { DrawerAmonestacion },
  data() {
    return {
      autoLoading: false,
      amonestacionData: [],
      amonestacionDataArticle: [],
      ColumnsDetalles: ColumnsAmonestacionForMonth,
      Title: "",
      amonestacionDrawer: false,
      actionRowData: false,

      actions: [
        {
          icon: "el-icon-view",
          label: "Ver",
          command: "view-task-view"
        },
        {
          icon: "el-icon-delete",
          label: "Eliminar",
          command: "delete-task"
        },
        {
          icon: "el-icon-plus",
          label: "Añadir Comentario",
          command: "add-commentary",
          condition: (row) => row.Type == "Llamado Atencion"
        }
      ]
    };
  },
  props: {
    showDrawerAmonestacionReport: {
      type: Boolean,
      default: false
    },
    UserId: {
      type: Number,
      default: 0
    },
    Month: {
      type: Number,
      default: 0
    },
    year: {
      type: Number,
      default: 0
    },
    type: {
      type: Number,
      default: 0
    }
  },
  watch: {
    showDrawerAmonestacionReport() {
      this.getDataForMonth(this.UserId, this.Month, this.year, this.type);
      //this.getDataForMonth2(this.UserId, this.Month, this.year);
    }
  },
  methods: {
    getDataForMonth(employee = null, month = null, year = null, type = null) {
      this.autoLoading = true;
      let params = {
        employeeID: employee,
        month: month,
        year: year,
        Type: type
      };
      this.$http
        .get("/api/Modules/GetAmonestacionListByMonth", { params })
        .then((resp) => {
          if (type == 1) {
            this.Title = "Listado Amonestacion";
          } else {
            this.Title = "Listado Llamado Atencion";
          }
          this.amonestacionData = resp.data;
        })
        .finally(() => {
          this.autoLoading = false;
        });
    },

    async onPushAction(action) {
      this.actionRowData = action;
      let rowFormInfo;
      let articles;

      if (action.row.Id) {
        let params = {
          warningRequestId: action.row.Id
        };
        try {
          const resp = await this.$http.get(
            "/api/Modules/GetAmonestacionForId",
            { params }
          );
          rowFormInfo = resp.data;
          articles = resp.data.ItemWarning;
        } catch (error) {
          console.error(error);
        } finally {
          this.autoLoading = false;
        }
      }

      this.amonestacionDrawer = true;

      let rowData = {
        task: action.row,
        rowforminfo: rowFormInfo,
        articless: articles
      };

      switch (action.command) {
        case "view-task-view":
          this.$refs.amonestacionForm.show(rowData, true, false);
          break;

        case "delete-task":
          await this.deleteAmonestacion(rowData.task);
          break;

        case "add-commentary":
          await this.addCommentary(rowData.task);
          break;
      }
    },
    closeDrawerDetalles() {
      this.$emit("dialog-closed");
    },

    async addCommentary(row) {
      let FormId = row.Id;
      //console.log("row", row);
      this.$prompt("Comentario", "Tip", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel"
      })
        .then(({ value }) => {
          const requestData = {
            Id: FormId,
            Commentary: value
          };
          this.$http
            .post("/api/Modules/AddCommentary", requestData)
            .then((resp) => {
              this.data = resp.data;
              //console.log("data", resp.data);
            })
            .catch((error) => {
              this.$message.error("Error al cargar detalles", error);
            });
          this.$message({
            type: "success",
            message: "Comentario Realizado"
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Input canceled"
          });
        });
    },

    async deleteAmonestacion(row) {
      let FormId = row.Id;
      let updated = false;

      this.$confirm("Estas seguro que deseas eliminar. Continue?", "Warning", {
        confirmButtonText: "OK",
        cancelButtonText: "Cancel",
        type: "warning"
      })
        .then(() => {
          this.autoLoading = true;
          this.$http
            .get("/api/Modules/DeleteAmonestacionForId?", {
              params: {
                warningRequestId: FormId
              }
            })
            .then(() => {
              vue.$message({
                message: "Amonestacion Eliminada",
                type: "success"
              });
              updated = true;
            })
            .catch((err) => {
              vue.$message({ type: "danger", message: err });
            })
            .finally(() => {
              this.getDataForMonth(
                this.UserId,
                this.Month,
                this.year,
                this.type
              );
              this.$emit("refreshTable");
            });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Confirmacion cancelada"
          });
        });
      if (updated) {
        return row;
      }
    }
  }
};
</script>
